import { umStorage } from '@nexelem/services';
import { useGraphneResourcesGroupList } from '../../../../../queryHooks/productionPlanHooks';
import { useEffect } from 'react';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

type SelectedResourceGroupState = {
  areaId?: number;
  setAreaId: (areaId?: number) => void;
};

export const useSelectedResourceGroupStore = create(
  persist(
    immer<SelectedResourceGroupState>((set) => {
      return {
        areaId: undefined,
        setAreaId: (areaId?: number) =>
          set(() => {
            return { areaId };
          }),
      };
    }),
    {
      name: 'selected-resource-group-store',
      storage: createJSONStorage(() => umStorage),
      // do not hydrate the store when user is not logged in, hydration is handled in Hydration.tsx component
      skipHydration: true,
    },
  ),
);

export const useSelectGanttResourceArea = () => {
  const { areaId, setAreaId } = useSelectedResourceGroupStore();
  const { data: areas, isFetched } = useGraphneResourcesGroupList();

  useEffect(() => {
    if (areas) {
      const areaIdExists = areas.some((area) => area.id === areaId);
      if (!areaIdExists) {
        setAreaId(areas[0]?.id);
      }
    }
  }, [areaId, areas, setAreaId]);

  return { areas, isFetched, areaId, setAreaId };
};
